import { NgModule } from '@angular/core';
import { SanitizePipeModule } from '@app/shared/pipes/sanitize/sanitize.module';
import { WucPictureModule } from '@inshared/website-ui-components';
import { ProductHeaderModule } from '../product-header/product-header.module';
import { SeoPageHeaderComponent } from './seo-page-header.component';
import { NgIf } from '@angular/common';

@NgModule({
    imports: [
        SanitizePipeModule,
        ProductHeaderModule,
        WucPictureModule,
        NgIf,
    ],
    exports: [SeoPageHeaderComponent],
    declarations: [SeoPageHeaderComponent],
})
export class SeoPageHeaderModule { }
